/**
 * The newest MOGZO CLI. Keep equal to `version` in packages/cli/package.json (a CLI test
 * checks): the API tells older CLIs about it, and the dashboard's docs show it.
 */
export const CLI_VERSION = '0.18.1';

/** Where the dashboard serves the CLI's install file (see apps/dev/scripts/prepare-downloads.mjs). */
export function cliDownloadUrl(dashboardUrl: string, version?: string): string {
  return `${dashboardUrl}/downloads/mogzo-cli${version ? `-${version}` : ''}.tgz`;
}

/** True when `latest` is a newer x.y.z version than `current` ("dev" builds never are behind). */
export function isNewerVersion(latest: string, current: string): boolean {
  const parse = (version: string) => version.split('-')[0]?.split('.').map(Number) ?? [];
  const [a, b] = [parse(latest), parse(current)];
  if (a.length !== 3 || b.length !== 3 || [...a, ...b].some(Number.isNaN)) return false;
  for (let i = 0; i < 3; i++) {
    if ((a[i] as number) !== (b[i] as number)) return (a[i] as number) > (b[i] as number);
  }
  return false;
}
